export default __webpack_public_path__ + "static/media/funnel.3e05aba5.svg";